/**
 * testing redux reducer
 * 
 * @author    Maurizio Tidei
 * @copyright © 2019 contexagon GmbH
 */


import {
    ACTIVATE_TEST_MODE,
    UPDATE_TEST_STATS
} from "./consts";


const initialState = {
    restcalls: 0,
    active: false
};


export default function activityReducer(state = initialState, action) {

    switch (action.type) {

        case UPDATE_TEST_STATS: {

            return {
                ...state,
                restcalls: state.restcalls + action.restcalls
            };
        }

        case ACTIVATE_TEST_MODE: {

            return {
                ...state,
                active: true
            }
        }

        default:
            return state;
    }
}
